import React from 'react';
import { styled } from '@mui/material';


const getFillColor = (color, theme) => {
  if (color === undefined) {
    return '';
  }
  if (['default', 'success', 'primary'].includes(color)) {
    return theme.palette.primary.main;
  }
  if (['inProgress', 'info', 'pending'].includes(color)) {
    return theme.palette.info.main;
  }
  if (['enabled', 'secondary', 'neutral'].includes(color)) {
    return theme.palette.secondary.main;
  }
  if (color === 'warning') return theme.palette.warning.main;
  if (color === 'error') return theme.palette.error.main;
  if (color === 'disabled') return theme.palette.disabled.main;
  return theme.palette.primary.main;
};

const StatusContainerStyled = styled('div', {
  name: 'Status',
  slot: 'root',
})({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '4px 0',
});

const StatusIconStyled = styled('svg', {
  name: 'Status',
  slot: 'icon',
  shouldForwardProp: (prop) => prop !== 'color',
})(({ theme, color }) => ({
  fill: getFillColor(color, theme),
  flexShrink: 0,
}));

const StatusLabelStyled = styled('label', {
  name: 'Status',
  slot: 'label',
})(({ theme }) => ({
  ...theme.typography.body3,
  textTransform: 'capitalize',
  color: 'inherit',
}));

const getLabel = (color) => {
  if (color === undefined) {
    return '';
  }
  if (['default', 'success', 'primary'].includes(color)) return 'Success';
  if (['inProgress', 'pending', 'info'].includes(color)) return 'Info';
  if (['enabled', 'secondary', 'neutral'].includes(color)) return 'Neutral';
  if (color === 'warning') return 'Warning';
  if (color === 'error') return 'Error';
  if (color === 'disabled') return 'Disabled';
  return '';
};

const Status = React.forwardRef(({
  children, color, hideLabel, ...props
}, ref,
) => (
  <StatusContainerStyled
    className={`Status-${color}`}
    ref={ref}
    data-testid={props['data-testid'] ?? 'status'}
    {...props}
  >
    <StatusIconStyled
      width='8'
      height='8'
      viewBox='0 0 8 8'
      color={color}
      data-testid={`${color}-status`}
    >
      <circle stroke='none' cx='4' cy='4' r='4' />
    </StatusIconStyled>
    {!hideLabel && (
      <StatusLabelStyled color={color}>
        {children || getLabel(color)}
      </StatusLabelStyled>
    )}
  </StatusContainerStyled>
));

export default Status;
